import { ErrorResetBoundary } from "@/components/shared/ErrorResetBoundary";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { BreadcrumbProvider } from "@/contexts/shared/breadcrumb";
import { Outlet } from "react-router";
import { AdminHeader } from "./AdminHeader";
import { AdminSidebar } from "./AdminSidebar";

const AdminLayout = () => {
    return (
        <div className="flex h-screen flex-col">
            <BreadcrumbProvider>
                <SidebarProvider className="flex flex-col">
                    <div className="flex min-h-0 flex-1">
                        <AdminSidebar />
                        <SidebarInset className="min-w-0">
                            <AdminHeader />
                            {/* [container-type:size] is the host contract
                            for descendants that size themselves to this
                            scrollport with 100cqh; without it cqh falls
                            back to viewport units, which ignore the
                            header and grow a second scrollbar. */}
                            <div className="[container-type:size] flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
                                <div className="flex flex-col gap-4 p-4 md:gap-6 md:p-6">
                                    <ErrorResetBoundary>
                                        <Outlet />
                                    </ErrorResetBoundary>
                                </div>
                            </div>
                        </SidebarInset>
                    </div>
                </SidebarProvider>
            </BreadcrumbProvider>
        </div>
    );
};

export default AdminLayout;
